import { render, staticRenderFns } from "./ResentConfirm.vue?vue&type=template&id=194ef512&"
import script from "./ResentConfirm.vue?vue&type=script&lang=js&"
export * from "./ResentConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports